/** DDIs mais comuns entre os clientes, para o pareamento por número. Brasil primeiro. */
export const COUNTRY_CODES: ReadonlyArray<{ ddi: string; name: string; flag: string }> = [
  { ddi: '55', name: 'Brasil', flag: '🇧🇷' },
  { ddi: '1', name: 'EUA / Canadá', flag: '🇺🇸' },
  { ddi: '351', name: 'Portugal', flag: '🇵🇹' },
  { ddi: '54', name: 'Argentina', flag: '🇦🇷' },
  { ddi: '52', name: 'México', flag: '🇲🇽' },
  { ddi: '56', name: 'Chile', flag: '🇨🇱' },
  { ddi: '57', name: 'Colômbia', flag: '🇨🇴' },
  { ddi: '51', name: 'Peru', flag: '🇵🇪' },
  { ddi: '598', name: 'Uruguai', flag: '🇺🇾' },
  { ddi: '595', name: 'Paraguai', flag: '🇵🇾' },
  { ddi: '34', name: 'Espanha', flag: '🇪🇸' },
  { ddi: '39', name: 'Itália', flag: '🇮🇹' },
  { ddi: '44', name: 'Reino Unido', flag: '🇬🇧' },
  { ddi: '49', name: 'Alemanha', flag: '🇩🇪' },
  { ddi: '33', name: 'França', flag: '🇫🇷' },
  { ddi: '244', name: 'Angola', flag: '🇦🇴' },
  { ddi: '258', name: 'Moçambique', flag: '🇲🇿' },
];
